/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-screentshot': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M6.23 4.73c.172-.375.27-.788.27-1.23a3 3 0 10-6 0 3 3 0 003 3c.442 0 .855-.098 1.23-.27L6.5 8 4.73 9.77A2.923 2.923 0 003.5 9.5a3 3 0 100 6 3 3 0 003-3c0-.443-.098-.855-.27-1.23L8 9.5l5.25 5.25h2.25V14L6.23 4.73zM3.5 5a1.5 1.5 0 11-.068-3A1.5 1.5 0 013.5 5zm0 9a1.5 1.5 0 11-.068-3 1.5 1.5 0 01.068 3zM8 8.375A.371.371 0 017.625 8c0-.21.165-.375.375-.375s.375.165.375.375-.165.375-.375.375zm5.25-7.125l-4.5 4.5 1.5 1.5L15.5 2v-.75h-2.25z" _fill="#646464"/>'
  }
})
